<div class="drill-down-wrap">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-hover w-100">
        <thead>
            <tr>
                <th>Serie / Nr. înreg.</th>
                <th>Data înreg.</th>
                <th>Categorie</th>
                <th>Tip document</th>
                <th>Sursă</th>
                <th>Status</th>
                <th>Termen</th>
                <th>Termen limită</th>
                <th>Observații</th>
                <th>Ultima preluare</th>
                <th class="text-center">Acțiuni</th>
            </tr>
        </thead>
    </table>

    <div class="drill-loader" *ngIf="isLoading">
        <mat-spinner [diameter]="28"></mat-spinner>
    </div>
</div>
